import axios from 'axios'

import emitter from '../utils/emitter'
import { srHide, srShow } from '../utils/srVisibility'
import scrollManager from '../utils/scrollManager'

import { FORM_ACTIONS } from './formValidation'

export const DISPO_MODAL_ACTIONS = {
  OPEN: 'DISPO_MODAL_OPEN',
}

export default {
  name: 'dispo-modal',

  options: {
    localesKey: 'disponibilityForm',
    endpoint: 'https://statement.bigyouth.fr/api/susbcription',
    method: 'POST',
  },

  ui: {
    closeButton: '[js-dispo-modal-close]',
    mail: '[js-dispo-modal-mail]',
    tel: '[js-dispo-modal-tel]',
    successLabel: '[js-dispo-modal-success]',
    errorLabel: '[js-dispo-modal-error]',
    locale: '[js-dispo-locale]',
  },

  events: [
    {
      on: 'click',
      target: 'closeButton',
      handle () {
        srHide(this.el)
        scrollManager.restart()
      },
    },
  ],

  componentDidMount () {
    emitter.on(DISPO_MODAL_ACTIONS.OPEN, (options) => {
      this.productSku = options.productSku
      srShow(this.el)
      setTimeout(function () {
        scrollManager.stop()
      }, 500)
    })

    emitter.on(FORM_ACTIONS.SUBMIT, this.handleFormSubmit)
  },

  handleFormSubmit (options) {
    if (this.props.formId === options.formId) {
      const bodyFormData = new FormData()
      bodyFormData.set('sku', this.productSku)
      bodyFormData.set('email', this.ui.mail.value)
      bodyFormData.set('tel', this.ui.tel.value)
      bodyFormData.set('locale', this.ui.locale.value)

      axios({
        url: this.options.endpoint,
        method: this.options.method,
        data: bodyFormData,
      })
        .then(this.handleFormSuccess.bind(this))
        .catch(this.handleFormError.bind(this))
    }
  },

  handleFormSuccess () {
    this.ui.mail.value = ''
    this.ui.tel.value = ''
    this.ui.successLabel.classList.remove('is-hidden')
    this.ui.errorLabel.classList.add('is-hidden')
  },

  handleFormError () {
    this.ui.successLabel.classList.add('is-hidden')
    this.ui.errorLabel.classList.remove('is-hidden')
  },
}
